import React from 'react';
import { Card } from '@/components/ui/card';
import { classNames } from '@/lib/format';

export function KpiCard({ label, value, delta, hint, tone = 'default', testId }) {
  const toneCls = {
    default: 'text-foreground',
    danger: 'text-red-500',
    warn: 'text-amber-500',
    ok: 'text-emerald-500',
    info: 'text-primary',
  }[tone];
  return (
    <Card className="p-4 border-border" data-testid={testId || 'kpi-card'}>
      <div className="text-[10px] uppercase tracking-[0.14em] text-muted-foreground">{label}</div>
      <div className="mt-1 flex items-baseline gap-2">
        <div className={classNames('font-mono tabular-nums text-2xl md:text-3xl font-semibold', toneCls)} data-testid="kpi-card-value">
          {value}
        </div>
        {delta !== undefined && (
          <div className="text-[10px] text-muted-foreground font-mono">{delta}</div>
        )}
      </div>
      {hint && <div className="mt-2 text-xs text-muted-foreground">{hint}</div>}
    </Card>
  );
}
